import { ElementRef } from '@angular/core';

export function ScrollIntoElement(
  element: ElementRef<HTMLElement>,
  options: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'center',
  }
) {
  if (element) {
    element.nativeElement.scrollIntoView(options);
  }
}

export function ScrollIntoHTMLElement(
  element: HTMLElement,
  options: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'center',
  }
) {
  if (element) {
    element.scrollIntoView(options);
  }
}
